export default {
    ordenadorConf: {},
    impresoras: [],
    balanza: null,
    readerBalanza: null,
    leerBalanza: false,
    pesoBalanza: 0,
    codigoLector: 0,
    dispositivosEnUso: []
}